import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { Link } from "react-router-dom";

const styles = theme => ({
    root: {
      flexGrow: 1,
      margin: 'auto',
    }
});
class SectionExample extends Component {
    routeChange = () => {
        window.location.href = "https://rkbaaz-skyy.firebaseapp.com";
    }
    render() {
        
        const { classes } = this.props;
        return (
            <div>
            <section className="example">
                <div className={classes.root}>
                    <Grid item xs={12} container>
                        <Grid item sm={6} xs={12} className="section_left">
                            
                        </Grid>
                        <Grid item sm={6} xs={12} className="section_right">
                            
                            <div className="exampleContent">
                                <h4>Example of money families <br/>have saved and continue to save</h4>
                                <div className="testimonial"><a>SUCCESS STORIES</a></div>
                            </div>

                            <Grid item xs={12} container>
                                <Grid item sm={2} xs={12} className="">
                                    <img src={require('../../assets/images/messageicon.png')} />
                                </Grid>
                                <Grid item sm={10} xs={12} className="">
                                    <div className="testimonialContent">
                                        <p className="testimonailText">
                                        kbaaz has been a lifesaver. My grandchildren will go to college without any debt!
                                        </p>
                                        <p className="testimonailUserName">Andy Abdelmalek</p>
                                        <p className="testimonailUserInfo">Kbaaz'er since 2017</p>
                                    </div>
                                </Grid>
                            </Grid>

                            
                        </Grid>
                        
                    </Grid>
                </div>
            </section>
            <section className="collection">
                <div className="badge">
                    <p className="badge_amount">$845</p>
                    <p className="badge_text">saved already</p>
                </div>
                <div className={classes.root}>
                    <Grid item xs={12} container>
                        <Grid item sm={12} xs={12} className="">
                        <h3 className="collectionAmount">$13,293</h3>
                        <p className="collectionContent">collected and distributed by <strong>kbaaz.com</strong>
                            <br/>We still continue to generate and save for the future!
                        </p>
                        <div className="event_host">
                        <Link to='/login' style={{ textDecoration: 'none' }}>
                            <Button variant="contained" className={classes.button}>
                                <img src={require('../../assets/images/hero-horn.png')} />Start Savings now!
                            </Button>
                        </Link>
                        </div>
                        </Grid>
                    </Grid>
                </div>
            </section>
            </div>
        )
    }
}
SectionExample.propTypes = {
    classes: PropTypes.object.isRequired,
  };
export default withStyles(styles)(SectionExample);


// WEBPACK FOOTER //
// ./src/components/Landing/SectionExample.js